import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class ActivityUserAssignmentListItemResponseDto {
  @ApiProperty({ type: 'string' })
  id!: string

  @ApiProperty({ type: 'string' })
  userId!: string

  @ApiPropertyOptional({ type: 'string', nullable: true })
  schoolYearCode!: string | null

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  availableFrom!: string | Date | null

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  dueAt!: string | Date | null
}

